import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fabric } from "@utils/fabric";
import { AppContext } from "../../context/AppContext";
import PropertyHint from "./shared/PropertyHint";

type ImageFitValue = "legacy" | "cover" | "contain";
type ImageWithFit = fabric.Image & { imageFit?: Exclude<ImageFitValue, "legacy"> };

function readImageFit(object: fabric.Object | null): ImageFitValue {
  const value = (object as ImageWithFit | null)?.imageFit;
  return value === "cover" || value === "contain" ? value : "legacy";
}

function ImageFit() {
  const { canvas, selectedObject } = useContext(AppContext);
  const { t } = useTranslation();
  const [value, setValue] = useState<ImageFitValue>(readImageFit(selectedObject));

  useEffect(() => {
    setValue(readImageFit(selectedObject));
  }, [selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const nextValue = event.target.value as ImageFitValue;
    const imageFit = nextValue === "legacy" ? undefined : nextValue;
    const image = selectedObject as ImageWithFit | null;

    image?.set({ imageFit } as any);
    setValue(nextValue);
    canvas?.requestRenderAll();
  }

  return (
    <>
      <select
        aria-label={t("properties_image_fit")}
        className="h-9 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
        value={value}
        onChange={onChange}
      >
        <option value="legacy">{t("properties_image_fit_legacy")}</option>
        <option value="cover">{t("properties_image_fit_cover")}</option>
        <option value="contain">{t("properties_image_fit_contain")}</option>
      </select>
      <PropertyHint>{t("properties_image_fit_help")}</PropertyHint>
    </>
  );
}

export default ImageFit;
